import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export const pluginKey = new PluginKey('betterTypeHistoryPlugin');
